module.exports = require('./dist');


// WEBPACK FOOTER //
// ./node_modules/vue-croppie/index.js